var _classCallCheck = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n3 = 0, F = function F() {}; return { s: F, n: function n() { return _n3 >= r.length ? { done: !0 } : { done: !1, value: r[_n3++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
!function (e) {
  var t = e.en = e.en || {};
  t.dictionary = Object.assign(t.dictionary || {}, {
    "Block quote": "Block quote"
  });
}(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})),
/*!
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
function () {
  var e = {
      446: function _(e, t, o) {
        "use strict";

        o.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var n = o(609),
          r = o.n(n)()(function (e) {
            return e[1];
          });
        r.push([e.id, ".ck-content blockquote{overflow:hidden;padding-right:1.5em;padding-left:1.5em;margin-left:0;margin-right:0;font-style:italic;border-left:5px solid #ccc}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}", ""]);
        var i = r;
      },
      609: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var o = e(t);
              return t[2] ? "@media ".concat(t[2], " {").concat(o, "}") : o;
            }).join("");
          }, t.i = function (e, o, n) {
            "string" == typeof e && (e = [[null, e, ""]]);
            var r = {};
            if (n) for (var i = 0; i < this.length; i++) {
              var c = this[i][0];
              null != c && (r[c] = !0);
            }
            for (var s = 0; s < e.length; s++) {
              var l = [].concat(e[s]);
              n && r[l[0]] || (o && (l[2] ? l[2] = "".concat(o, " and ").concat(l[2]) : l[2] = o), t.push(l));
            }
          }, t;
        };
      },
      62: function _(e, t, o) {
        "use strict";

        var n,
          r = function r() {
            return void 0 === n && (n = Boolean(window && document && document.all && !window.atob)), n;
          },
          i = function () {
            var e = {};
            return function (t) {
              if (void 0 === e[t]) {
                var o = document.querySelector(t);
                if (window.HTMLIFrameElement && o instanceof window.HTMLIFrameElement) try {
                  o = o.contentDocument.head;
                } catch (e) {
                  o = null;
                }
                e[t] = o;
              }
              return e[t];
            };
          }(),
          c = [];
        function s(e) {
          for (var t = -1, o = 0; o < c.length; o++) if (c[o].identifier === e) {
            t = o;
            break;
          }
          return t;
        }
        function l(e, t) {
          for (var o = {}, n = [], r = 0; r < e.length; r++) {
            var i = e[r],
              l = t.base ? i[0] + t.base : i[0],
              a = o[l] || 0,
              u = "".concat(l, " ").concat(a);
            o[l] = a + 1;
            var d = s(u),
              f = {
                css: i[1],
                media: i[2],
                sourceMap: i[3]
              };
            -1 !== d ? (c[d].references++, c[d].updater(f)) : c.push({
              identifier: u,
              updater: v(f, t),
              references: 1
            }), n.push(u);
          }
          return n;
        }
        function a(e) {
          var t = document.createElement("style"),
            n = e.attributes || {};
          if (void 0 === n.nonce) {
            var r = o.nc;
            r && (n.nonce = r);
          }
          if (Object.keys(n).forEach(function (e) {
            t.setAttribute(e, n[e]);
          }), "function" == typeof e.insert) e.insert(t);else {
            var c = i(e.insert || "head");
            if (!c) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            c.appendChild(t);
          }
          return t;
        }
        var u,
          d = (u = [], function (e, t) {
            return u[e] = t, u.filter(Boolean).join("\n");
          });
        function f(e, t, o, n) {
          var r = o ? "" : n.media ? "@media ".concat(n.media, " {").concat(n.css, "}") : n.css;
          if (e.styleSheet) e.styleSheet.cssText = d(t, r);else {
            var i = document.createTextNode(r),
              c = e.childNodes;
            c[t] && e.removeChild(c[t]), c.length ? e.insertBefore(i, c[t]) : e.appendChild(i);
          }
        }
        function p(e, t, o) {
          var n = o.css,
            r = o.media,
            i = o.sourceMap;
          if (r ? e.setAttribute("media", r) : e.removeAttribute("media"), i && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), e.styleSheet) e.styleSheet.cssText = n;else {
            for (; e.firstChild;) e.removeChild(e.firstChild);
            e.appendChild(document.createTextNode(n));
          }
        }
        var m = null,
          h = 0;
        function v(e, t) {
          var o, n, r;
          if (t.singleton) {
            var i = h++;
            o = m || (m = a(t)), n = f.bind(null, o, i, !1), r = f.bind(null, o, i, !0);
          } else o = a(t), n = p.bind(null, o, t), r = function r() {
            !function (e) {
              if (null === e.parentNode) return !1;
              e.parentNode.removeChild(e);
            }(o);
          };
          return n(e), function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
              n(e = t);
            } else r();
          };
        }
        e.exports = function (e, t) {
          (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = r());
          var o = l(e = e || [], t);
          return function (e) {
            if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
              for (var n = 0; n < o.length; n++) {
                var r = s(o[n]);
                c[r].references--;
              }
              for (var i = l(e, t), a = 0; a < o.length; a++) {
                var u = s(o[a]);
                0 === c[u].references && (c[u].updater(), c.splice(u, 1));
              }
              o = i;
            }
          };
        };
      },
      704: function _(e, t, o) {
        e.exports = o(79)("./src/core.js");
      },
      331: function _(e, t, o) {
        e.exports = o(79)("./src/enter.js");
      },
      181: function _(e, t, o) {
        e.exports = o(79)("./src/typing.js");
      },
      273: function _(e, t, o) {
        e.exports = o(79)("./src/ui.js");
      },
      209: function _(e, t, o) {
        e.exports = o(79)("./src/utils.js");
      },
      79: function _(e) {
        "use strict";

        e.exports = CKEditor5.dll;
      }
    },
    t = {};
  function o(n) {
    var r = t[n];
    if (void 0 !== r) return r.exports;
    var i = t[n] = {
      id: n,
      exports: {}
    };
    return e[n](i, i.exports, o), i.exports;
  }
  o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, {
      a: t
    }), t;
  }, o.d = function (e, t) {
    for (var n in t) o.o(t, n) && !o.o(e, n) && Object.defineProperty(e, n, {
      enumerable: !0,
      get: t[n]
    });
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var n = {};
  (function () {
    "use strict";

    o.r(n), o.d(n, {
      BlockQuote: function BlockQuote() {
        return g;
      },
      BlockQuoteEditing: function BlockQuoteEditing() {
        return u;
      },
      BlockQuoteUI: function BlockQuoteUI() {
        return v;
      }
    });
    var e = o(704),
      t = o(331),
      r = o(181),
      i = o(209);
    var c = /*#__PURE__*/function (_e$Command) {
      _inherits(c, _e$Command);
      function c() {
        _classCallCheck(this, c);
        return _possibleConstructorReturn(this, _getPrototypeOf(c).apply(this, arguments));
      }
      _createClass(c, [{
        key: "refresh",
        value: function refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this = this;
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var t = this.editor.model,
            o = t.schema,
            n = t.document.selection,
            r = Array.from(n.getSelectedBlocks()),
            i = void 0 === e.forceValue ? !this.value : e.forceValue;
          t.change(function (e) {
            if (i) {
              var _t = r.filter(function (e) {
                return s(e) || a(o, e);
              });
              _this._applyQuote(e, _t);
            } else _this._removeQuote(e, r.filter(s));
          });
        }
      }, {
        key: "_getValue",
        value: function _getValue() {
          var e = this.editor.model.document.selection,
            t = (0, i.first)(e.getSelectedBlocks());
          return !(!t || !s(t));
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          if (this.value) return !0;
          var e = this.editor.model.document.selection,
            t = this.editor.model.schema,
            o = (0, i.first)(e.getSelectedBlocks());
          return !!o && a(t, o);
        }
      }, {
        key: "_removeQuote",
        value: function _removeQuote(e, t) {
          l(e, t).reverse().forEach(function (t) {
            if (t.start.isAtStart && t.end.isAtEnd) return void e.unwrap(t.start.parent);
            if (t.start.isAtStart) {
              var _o = e.createPositionBefore(t.start.parent);
              return void e.move(t, _o);
            }
            t.end.isAtEnd || e.split(t.end);
            var o = e.createPositionAfter(t.end.parent);
            e.move(t, o);
          });
        }
      }, {
        key: "_applyQuote",
        value: function _applyQuote(e, t) {
          var o = [];
          l(e, t).reverse().forEach(function (t) {
            var n = s(t.start);
            n || (n = e.createElement("blockQuote"), e.wrap(t, n)), o.push(n);
          }), o.reverse().reduce(function (t, o) {
            return t.nextSibling == o ? (e.merge(e.createPositionAfter(t)), t) : o;
          });
        }
      }]);
      return c;
    }(e.Command);
    function s(e) {
      return "blockQuote" == e.parent.name ? e.parent : null;
    }
    function l(e, t) {
      var o,
        n = 0;
      var r = [];
      for (; n < t.length;) {
        var _i = t[n],
          _c = t[n + 1];
        o || (o = e.createPositionBefore(_i)), _c && _i.nextSibling == _c || (r.push(e.createRange(o, e.createPositionAfter(_i))), o = null), n++;
      }
      return r;
    }
    function a(e, t) {
      var o = e.checkChild(t.parent, "blockQuote"),
        n = e.checkChild(["$root", "blockQuote"], t);
      return o && n;
    }
    var u = /*#__PURE__*/function (_e$Plugin) {
      _inherits(u, _e$Plugin);
      function u() {
        _classCallCheck(this, u);
        return _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments));
      }
      _createClass(u, [{
        key: "init",
        value: function init() {
          var e = this.editor,
            t = e.model.schema;
          e.commands.add("blockQuote", new c(e)), t.register("blockQuote", {
            allowWhere: "$block",
            allowContentOf: "$root"
          }), e.conversion.elementToElement({
            model: "blockQuote",
            view: "blockquote"
          }), e.model.document.registerPostFixer(function (o) {
            var n = e.model.document.differ.getChanges();
            var _iterator = _createForOfIteratorHelper(n),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _e = _step.value;
                if ("insert" == _e.type) {
                  var _n = _e.position.nodeAfter;
                  if (!_n) continue;
                  if (_n.is("element", "blockQuote") && _n.isEmpty) return o.remove(_n), !0;
                  if (_n.is("element", "blockQuote") && !t.checkChild(_e.position, _n)) return o.unwrap(_n), !0;
                  if (_n.is("element")) {
                    var _e2 = o.createRangeIn(_n);
                    var _iterator2 = _createForOfIteratorHelper(_e2.getItems()),
                      _step2;
                    try {
                      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        var _n2 = _step2.value;
                        if (_n2.is("element", "blockQuote") && !t.checkChild(o.createPositionBefore(_n2), _n2)) return o.unwrap(_n2), !0;
                      }
                    } catch (err) {
                      _iterator2.e(err);
                    } finally {
                      _iterator2.f();
                    }
                  }
                } else if ("remove" == _e.type) {
                  var _t2 = _e.position.parent;
                  if (_t2.is("element", "blockQuote") && _t2.isEmpty) return o.remove(_t2), !0;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            return !1;
          });
          var o = this.editor.editing.view.document,
            n = e.model.document.selection,
            r = e.commands.get("blockQuote");
          this.listenTo(o, "enter", function (t, o) {
            if (!n.isCollapsed || !r.value) return;
            n.getLastPosition().parent.isEmpty && (e.execute("blockQuote"), e.editing.view.scrollToTheSelection(), o.preventDefault(), t.stop());
          }, {
            context: "blockquote"
          }), this.listenTo(o, "delete", function (t, o) {
            if ("backward" != o.direction || !n.isCollapsed || !r.value) return;
            var i = n.getLastPosition().parent;
            i.isEmpty && !i.previousSibling && (e.execute("blockQuote"), e.editing.view.scrollToTheSelection(), o.preventDefault(), t.stop());
          }, {
            context: "blockquote"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "BlockQuoteEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [t.Enter, r.Delete];
        }
      }]);
      return u;
    }(e.Plugin);
    var d = o(273),
      f = o(62),
      p = o.n(f),
      m = o(446),
      h = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    p()(m.Z, h);
    m.Z.locals;
    var v = /*#__PURE__*/function (_e$Plugin2) {
      _inherits(v, _e$Plugin2);
      function v() {
        _classCallCheck(this, v);
        return _possibleConstructorReturn(this, _getPrototypeOf(v).apply(this, arguments));
      }
      _createClass(v, [{
        key: "init",
        value: function init() {
          var _this2 = this;
          var t = this.editor,
            o = t.t;
          t.ui.componentFactory.add("blockQuote", function (n) {
            var r = t.commands.get("blockQuote"),
              i = new d.ButtonView(n);
            return i.set({
              label: o("Block quote"),
              icon: e.icons.quote,
              tooltip: !0,
              isToggleable: !0
            }), i.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), _this2.listenTo(i, "execute", function () {
              t.execute("blockQuote"), t.editing.view.focus();
            }), i;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "BlockQuoteUI";
        }
      }]);
      return v;
    }(e.Plugin);
    var g = /*#__PURE__*/function (_e$Plugin3) {
      _inherits(g, _e$Plugin3);
      function g() {
        _classCallCheck(this, g);
        return _possibleConstructorReturn(this, _getPrototypeOf(g).apply(this, arguments));
      }
      _createClass(g, null, [{
        key: "requires",
        get: function get() {
          return [u, v];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "BlockQuote";
        }
      }]);
      return g;
    }(e.Plugin);
  })(), (window.CKEditor5 = window.CKEditor5 || {}).blockQuote = n;
}();